import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import index from '../views/index.vue'
import h5 from '../views/h5/index'
Vue.use(VueRouter)

const routes = [
	{ path: '/login', name: 'Login', component: Login },
	//{ path: '/dbcheck', name: 'dbcheck', component: resolve => require(['../views/sys/dbcheck'], resolve) },
	{ path: '*', redirect: "/home" },
	{
		path: '/index',
		name: 'index',
		component: index,
		children: [
			{ path: '/home', component: resolve => require(['../views/home/home'], resolve) },
			{ path: '/iframe', component: resolve => require(['../views/sys/sys_iframe.vue'], resolve) },
			{ path: '/sys_menu', component: resolve => require(['../views/sys/sys_menu'], resolve) },
			{ path: '/sys_role', component: resolve => require(['../views/sys/sys_role'], resolve) },
			{ path: '/sys_teacherDept', component: resolve => require(['../views/sys/sys_teacherDept'], resolve) },
			{ path: '/teacher', component: resolve => require(['../views/sys/teacher'], resolve) },
			{ path: '/tchdetail', component: resolve => require(['../views/sys/tchDetail'], resolve) },
			{ path: '/student', component: resolve => require(['../views/sys/student'], resolve) },
			{ path: '/stubzr', component: resolve => require(['../views/sys/studentbzr'], resolve) },
			{ path: '/directory', component: resolve => require(['../views/sys/directory'], resolve) },
			{ path: '/sys_modules', component: resolve => require(['../views/sys/sys_module'], resolve) },
			{ path: '/init', component: resolve => require(['../views/sys/theme'], resolve) },
			{ path: '/banner', component: resolve => require(['../views/sys/banner.vue'], resolve) },
			{ path: '/sports_project', component: resolve => require(['../views/sports/project.vue'], resolve) },
			{ path: '/sports_class', component: resolve => require(['../views/sports/class'], resolve) },
			{ path: '/lessons', component: resolve => require(['../views/sports/lessons'], resolve) },
			{ path: '/venue', component: resolve => require(['../views/sports/venue'], resolve) },
			{ path: '/sites', component: resolve => require(['../views/sports/sites'], resolve) },
			{ path: '/site_reserve', component: resolve => require(['../views/sports/siteReserve'], resolve) },
			{ path: '/coaches', component: resolve => require(['../views/sys/teacher'], resolve) },
			{ path: '/sportsmen', component: resolve => require(['../views/sys/student'], resolve) },
			{ path: '/teams', component: resolve => require(['../views/sports/teams'], resolve) },
			{ path: '/coaches_lessons', component: resolve => require(['../views/sports/coachesLessons'], resolve) },
			{ path: '/training_plan', component: resolve => require(['../views/sports/trainingPlan'], resolve) },
			{ path: '/lesson_plan', component: resolve => require(['../views/sports/lessonPlan'], resolve) },
			{ path: '/lesson_time', component: resolve => require(['../views/sports/lessonTime'], resolve) },
			{ path: '/course_reserve', component: resolve => require(['../views/sports/courseReserve'], resolve) },
			{ path: '/select_courses', component: resolve => require(['../views/sports/courseReserve'], resolve) },
			{ path: '/ssxx', component: resolve => require(['../views/sports/ssxx'], resolve) },
			{ path: '/sshd', component: resolve => require(['../views/sports/sshd'], resolve) },
			{ path: '/cjgl', component: resolve => require(['../views/sports/score'], resolve) },
			{ path: '/teaching_videos', component: resolve => require(['../views/sports/teachingVideo'], resolve) },

		]
	},
	//手机端的页面放这里
	{
		path: "/h5",
		component: h5,
		redirect: "/",
		children: [
			{ path: '/h5_reserve_cg', component: resolve => require(['../views/h5/reserve_cg.vue'], resolve) },
			{ path: '/h5_reserve_list', component: resolve => require(['../views/h5/reserve_list.vue'], resolve) },
			{ path: '/h5_reserve_detail', component: resolve => require(['../views/h5/reserve_detail.vue'], resolve) },
		]
	}
]


const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})


//获取url参数的方法，支持vue路由各种参数写法
const $request = function (name) {
	var params = [];
	var value = null;
	if (window.location.href.indexOf(name + "=") >= 0) {
		let q = window.location.href.split("?")[1];
		if (q.indexOf("#") > 0) {
			q = q.split("#")[0];
		}
		params = q.split("&");
		for (let p of params) {
			if (p.indexOf(name + "=") >= 0) {
				value = p.replace(name + "=", "").replace(/\//g, "")
				break;
			}
		}
	}
	if (value && value != undefined && value != "undefined") {
		return value
	} else {
		return "";
	}
}


//路由进入之前检查是否登录
router.beforeEach((to, from, next) => {
	let auth = $request("auth"); //检查url是否带有登录字符串
	let whiteList = ['/login', '/h5_reserve_cg', '/h5_reserve_list','/h5_reserve_detail']
	if (auth) {
		window.localStorage.setItem("auth", auth); //将登录字符串保存到缓存
		//移除url的auth并刷新页面
		let localUrl = window.location.href.replace(auth, '').replace("?auth=", '').replace("&auth=", '')
		window.location.href = localUrl
		window.location.reload()
	} else { //跳转统一登录
		if (window.localStorage.getItem("auth")) { //检查本地是否登录
			next()
		} else {
			console.log(to.path)
			if (whiteList.indexOf(to.path) >= 0) {
				next()
			} else {
				next({ path: "/login" })
			}
		}
	}
})



export default router
